if (!customElements.get('caldrenova-charm-upsell')) {
  customElements.define('caldrenova-charm-upsell', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      this.addEventListener('change', () => this.updateButton());
      this.querySelector('[data-charm-add]')?.addEventListener('click', () => this.addSelected());
      this.querySelectorAll('[data-charm-scroll]').forEach(button => {
        button.addEventListener('click', () => {
          const track = this.querySelector('[data-charm-track]');
          if (!track) return;
          track.scrollBy({ left: (Number(button.dataset.charmScroll) || 1) * track.clientWidth * .78, behavior: 'smooth' });
        });
      });
      this.updateButton();
    }
    updateButton() {
      const selected = this.querySelectorAll('[data-charm-checkbox]:checked').length;
      const button = this.querySelector('[data-charm-add]');
      if (button) {
        button.disabled = selected === 0;
        button.textContent = selected ? 'Add selected charms (' + selected + ')' : 'Add selected charms';
      }
    }
    async addSelected() {
      const button = this.querySelector('[data-charm-add]');
      const status = this.querySelector('[data-charm-status]');
      const cards = [...this.querySelectorAll('[data-charm-card]')].filter(card => card.querySelector('[data-charm-checkbox]')?.checked);
      const items = cards.map(card => ({ id: Number(card.querySelector('[data-charm-variant]')?.value), quantity: 1 })).filter(item => Number.isSafeInteger(item.id) && item.id > 0);
      if (!items.length || !button) return;
      button.disabled = true;
      if (status) status.textContent = 'Adding selected charms…';
      const root = window.Shopify?.routes?.root || '/';
      try {
        const response = await fetch(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type':'application/json','Accept':'application/json' }, body: JSON.stringify({ items }) });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'Could not add these charms.');
        window.location.assign(root + 'cart');
      } catch (error) {
        if (status) status.textContent = error instanceof Error ? error.message : 'Unable to add charms. Please try again.';
        this.updateButton();
      }
    }
  });
}
